// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,ScoreCard,StatsGraph
}
                         from '../../components';
// import
import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../components';


class Revenue extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Revenue');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    $('.revenue-trend').find("a").trigger("click");
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Revenue');
  }

  // tab headers (in state for example):
  state = {
    headers: [
      {name: 'Data', tablink: 'about', isActive: true},    
      {name: 'Revenue Trend', tablink: 'home', isActive: false},
    ]
  };  

  render() {
    const {
      statsTable,scoreCard,statsGraph,
    } = this.props;
    
    const { 
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;    
    return(
      <AnimatedView>

        <div className="row">
          <div className="col-md-12">
            <ScoreCard name="revenue_score_card" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>          
          </div>                  
        </div>

        <div className="row">
          <div className="col-md-12 revenue-trend">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.headers}/>
              <TabPanelBody>
                <TabPanelBodyContent id="home">
                  <StatsGraph type="bar" name="revenue_per_month_by_program" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="about">
                  <StatsTable name="revenue_per_month_by_program" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel> 
          </div>                  
        </div>                     

        <div className="row">
          <div className="col-md-4">
            <StatsTable name="revenue_breakup_by_program" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-4">
            <StatsTable name="revenue_breakup_by_package" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>                
          <div className="col-md-4">
            <StatsTable name="revenue_breakup_by_package_duration" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>                          
        </div>        
      </AnimatedView>
    );
  }
}

export default Revenue;



// WEBPACK FOOTER //
// ./src/app/views/revenue/Revenue.js